import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Table,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Container,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { extractIdFromUrl, showToast } from "../../helper-methods";
import { convertUrlToCdn } from "../../helper-methods";
import {
  clearActivities,
  DeleteMemberAndGroup,
  updateSubscriptionEndDate,
  viewMembers,
  getVerificationStatus,
  verifyUser,
} from "../../http/http-calls";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import DeleteAlertModal from "../../components/modals/DeleteAlertModal";
import { Oval } from "react-loader-spinner";
import SubscriptionPlanModal from "../../components/modals/subscriptionPlanModal";
import EditMemberModal from "../../components/modals/EditMemberModal";
import toast from "react-hot-toast";

const MembersviewPage = () => {
  const navigate = useNavigate();
  const memberId = extractIdFromUrl();

  // state
  const [isEmbeddedLoading, setIsEmbeddedLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  //state

  const [user, setUser] = useState({});
  const [delModeOpen, setDelModeOpen] = useState(false);
  const [deleteId, setDelId] = useState("");
  const [activities, setActivities] = useState([]);
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [verifying, setVerifying] = useState(null);
  const [liveDate, setLiveDate] = useState();

  const [isOpen, setIsOpen] = useState(false);
  const [subscription, setSubscription] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editUserDetail, setEditUserDetail] = useState({});

  const _toggle = (isOpen = false, subscriptionPlan) => {
    setIsOpen(isOpen);
    setSubscription(subscriptionPlan);
  };
  //view member details

  const _memberDetailsHandler = async () => {
    // Only show embedded loader for filtering, not initial load
    if (!isInitialLoad) setIsEmbeddedLoading(true);

    try {
      const res = await viewMembers(memberId);
      setUser(res.user);
      setActivities(res.userActivities);
      date(res.userActivities);
      if (!isInitialLoad) setIsEmbeddedLoading(false);
      if (isInitialLoad) setIsInitialLoad(false);
    } catch (error) {
      console.log(error);
      if (!isInitialLoad) setIsEmbeddedLoading(false);
      if (isInitialLoad) setIsInitialLoad(false);
    }
  };

  /* eslint-disable */
  useEffect(() => {
    _memberDetailsHandler();
  }, []);

  useEffect(() => {
    const fetchVerificationStatus = async () => {
      try {
        if (!memberId || !user?.email) return;
        const res = await getVerificationStatus({
          type: "EMAIL",
          userId: memberId,
        });
        if (res && res.length > 0) {
          const hasVerified = res.some((item) => item.verified === true);
          if (hasVerified) {
            setVerificationStatus(true);
          } else {
            setVerificationStatus(null);
          }
        } else {
          setVerificationStatus(null);
        }
      } catch (error) {
        setVerificationStatus(null);
        // Optionally log error
      }
    };
    fetchVerificationStatus();
  }, [memberId, user?.email]);

  const handleUserVerification = async () => {
    setVerifying(true);
    try {
      const res = await verifyUser({
        type: "EMAIL",
        target: user.email,
        userId: memberId,
        verified: true,
        sendVerification: true,
      });
      if (res && !res.error) {
        setVerificationStatus(true);
        toast.success("User verified successfully");
      } else {
        setVerificationStatus(null);
        toast.error(res?.message || "Failed to verify user");
      }
    } catch (error) {
      setVerificationStatus(null);
      toast.error("Failed to verify user");
    }
  };

  //delete group joined member

  const _removeMember = async (memberId) => {
    // console.log(memberId);
    _deleteToggle(true, memberId);
  };
  const _deleteToggle = (delModeOpen = false, id) => {
    setDelModeOpen(delModeOpen);
    setDelId(id);
  };

  //api call for delete member
  const _deleteMemberFromJoinedGroupHandler = async () => {
    try {
      const res = await DeleteMemberAndGroup(deleteId, memberId);
      _memberDetailsHandler();
    } catch (error) {
      showToast(error.message, "error");
    }
  };

  //activities clear
  const _clearAllActivities = async (id) => {
    try {
      const res = await clearActivities(id);
      _memberDetailsHandler();
    } catch (error) {
      console.log("error", error);
    }
  };

  const date = (activity) => {
    let created;

    for (let i = 0; i < activity.length; i++) {
      const today = moment().isSame(activity[i].createdAt, "day");

      if (today === true) {
        created = moment(activity[i].createdAt).startOf("hour").fromNow();
      }

      if (today !== true) {
        created = moment(activity[i].createdAt).format("dddd , h:mm a");
      }

      setLiveDate(created);
      return created;
    }
  };

  const _editHandler = (details) => {
    _toggleMemberDetail(true);
    setEditUserDetail(details);
  };

  const _toggleMemberDetail = (isModalOpen = false) => {
    setIsModalOpen(isModalOpen);
    setEditUserDetail(null);
  };

  return (
    <React.Fragment>
      {isEmbeddedLoading ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            margin: "40px 0",
            minHeight: "400px",
            alignItems: "center",
          }}
        >
          <Oval color="#3498DB" />
        </div>
      ) : (
        <>
          <Container>
            <div className="innerHeader">
              {/* page title */}
              <Link to="/members" className="fs-16">
                <i className="fa fa-chevron-left me-1"></i> Back To Members
              </Link>
            </div>

            <Row>
              <Col xl="4">
                <Card className="ProfileCard">
                  <CardHeader></CardHeader>
                  <CardBody>
                    <div className="userProfile vertical-align">
                      <img
                        src={
                          user.displaypictureurl
                            ? convertUrlToCdn(user.displaypictureurl)
                            : require("../../assets/img/default-profile.svg")
                                .default
                        }
                        alt="user"
                      />
                      <div className="profile_info">
                        <h1 className="text-primary">{user.fullname}</h1>
                        <span>
                          <i
                            title="Update Member"
                            className="fas fa-pencil-alt edit ml-1"
                            onClick={() => _editHandler(user)}
                          />
                        </span>
                      </div>
                    </div>

                    {/* List Group */}
                    <ListGroup className="profileListGroup mt-2 w-100">
                      <ListGroupItem>
                        <p>Email:</p>
                        <div>{user.email}</div>
                      </ListGroupItem>
                      <ListGroupItem>
                        <p>Phone:</p>
                        <div>{user.phone}</div>
                      </ListGroupItem>
                      <ListGroupItem>
                        <p>Member Since:</p>
                        <div>
                          {moment(user.createdAt).format("DD MMM YYYY")}
                        </div>
                      </ListGroupItem>
                      <ListGroupItem>
                        <p>KYC:</p>
                        <div>{user.isKycDone ? "Done" : "Pending"}</div>
                      </ListGroupItem>
                      <ListGroupItem>
                        <p>Verified:</p>
                        <div>
                          {verificationStatus ? (
                            <div className="text-success">
                              <i className="fa fa-check-circle me-1"></i>
                              Verified
                            </div>
                          ) : (
                            <>
                              <Button
                                color="primary"
                                outline
                                size="sm"
                                onClick={handleUserVerification}
                              >
                                {verifying ? "Verifying..." : "Verify User"}
                              </Button>
                            </>
                          )}
                        </div>
                      </ListGroupItem>
                      {user?.customerStripeId && (
                        <ListGroupItem>
                          <p>Customer Stripe Page</p>
                          <a
                            href={`https://dashboard.stripe.com/customers/${user?.customerStripeId}`}
                            target="_blank"
                          >
                            {user.customerStripeId}
                          </a>
                        </ListGroupItem>
                      )}
                      {user?.stripeId && (
                        <ListGroupItem>
                          <p>Payout Stripe Page</p>
                          <a
                            href={`https://dashboard.stripe.com/connect/accounts/${user.stripeId}`}
                            target="_blank"
                          >
                            {user.stripeId}
                          </a>
                        </ListGroupItem>
                      )}
                    </ListGroup>
                  </CardBody>
                </Card>
              </Col>

              <Col xl="8" className="mt-4 mt-xl-0">
                <Card body className="ProfileCard">
                  <div className="d-flex align-items-center justify-content-between">
                    <h4 className="fs-18 mb-0">Activities</h4>
                    <Button
                      color="link"
                      className="fs-12"
                      onClick={() => _clearAllActivities(user._id)}
                    >
                      Clear All
                    </Button>
                  </div>
                  <div className="activityContainer">
                    <ListGroup>
                      {activities?.map((item, index) => (
                        <ListGroupItem className="unread" key={index}>
                          <div className="d-flex align-items-center">
                            <div className="activityImg">
                              <img
                                src={
                                  user.displaypictureurl
                                    ? convertUrlToCdn(user.displaypictureurl)
                                    : require("../../assets/img/default-profile.svg")
                                        .default
                                }
                                alt=""
                              />
                            </div>
                            <div className="activityText">
                              <p>
                                <b>{user.fullname}</b> {item.title}.
                              </p>

                              <div className="time-date">
                                {/* <span>{moment(item.updatedAt).format("dddd")} at {moment(item.updatedAt).format("h:mm a")}</span> */}
                                <span>{liveDate}</span>
                              </div>
                            </div>
                          </div>
                          {/* <i className="fa fa-ellipsis-h"></i> */}
                        </ListGroupItem>
                      ))}
                    </ListGroup>
                  </div>
                </Card>
              </Col>
              {user?._myGrouped?.length > 0 && (
                <Col xl="6" className="mt-4">
                  {/* Groups Created */}
                  <Card body className="ProfileCard">
                    <h4 className="fs-18 mb-3">Groups Created</h4>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Group</th>
                          <th>Created On</th>
                          <th>Subscription</th>
                          <th>Earned</th>
                          <th>Members</th>
                          <th>Spent</th>
                        </tr>
                      </thead>
                      {user?._myGrouped?.map((member, index) => (
                        <tbody key={index}>
                          <tr>
                            <td
                              className="tableLink"
                              onClick={() =>
                                navigate(`/groups-view/${member._id}`)
                              }
                            >
                              {member.name}
                            </td>
                            <td>
                              {moment(member.createdAt).format("DD MMM YYYY")}
                            </td>
                            <td>
                              <Link
                                to=""
                                onClick={() =>
                                  _toggle(true, member.subscriptionPlan)
                                }
                              >
                                View Plan
                              </Link>
                            </td>
                            <td>
                              {typeof member.revenue?.totalRevenue ===
                                "number" &&
                              typeof member.revenue?.groupedRevenue === "number"
                                ? member.revenue.totalRevenue -
                                  member.revenue.groupedRevenue
                                : 0}
                            </td>
                            <td>{member.memberCount}</td>
                            <td>
                              {typeof member.revenue?.groupedCharge ===
                                "number" && !isNaN(member.revenue.groupedCharge)
                                ? member.revenue.groupedCharge
                                : 0}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                    </Table>
                  </Card>
                </Col>
              )}

              <Col
                xl={user?._myGrouped?.length > 0 ? "6" : "12"}
                className="mt-4"
              >
                {/* Groups Joined */}
                <Card body className="ProfileCard">
                  <h4 className="fs-18 mb-3">Groups Joined</h4>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Group</th>
                        <th>Joined On</th>
                        <th>Subscription End Date</th>
                        <th>Subscription Charge</th>
                        <th>Media Charge</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    {user?._joinGrouped?.map((join, index) => (
                      <JoinedGroup
                        join={join}
                        key={index}
                        userId={user?._id}
                        _removeMember={_removeMember}
                      />
                    ))}
                  </Table>
                </Card>
              </Col>
              {user?._previouslyJoinGrouped?.length && (
                <Col
                  xl={user?._myGrouped?.length > 0 ? "6" : "12"}
                  className="mt-4"
                >
                  {/* Groups Joined */}
                  <Card body className="ProfileCard">
                    <h4 className="fs-18 mb-3">Previsouly Joined Groups</h4>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Group</th>
                          <th>Joined On</th>
                          <th>Subscription End Date</th>
                          <th>Subscription Charge</th>
                          <th>Media Charge</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      {user?._previouslyJoinGrouped?.map((join, index) => (
                        <JoinedGroup
                          join={join}
                          key={index}
                          userId={user?._id}
                          _removeMember={_removeMember}
                        />
                      ))}
                    </Table>
                  </Card>
                </Col>
              )}
            </Row>

            {isModalOpen ? (
              <EditMemberModal
                isOpen={isModalOpen}
                toggle={() => _toggleMemberDetail()}
                editUserDetail={editUserDetail}
                memberDetail={_memberDetailsHandler}
              />
            ) : null}
            <SubscriptionPlanModal
              isOpen={isOpen}
              toggle={() => _toggle()}
              subscription={subscription}
            />

            {/* pagination */}
            {/* <PaginatedItems itemsPerPage={4} /> */}
            <DeleteAlertModal
              delModeOpen={delModeOpen}
              deleteMemberView={() => _deleteMemberFromJoinedGroupHandler()}
              toggle={() => _deleteToggle()}
            />
          </Container>
        </>
      )}
    </React.Fragment>
  );
};
const JoinedGroup = ({ join, userId, _removeMember }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [date, setDate] = useState(join.subscriptionEndDate);

  const handleChangeDate = async () => {
    const res = await updateSubscriptionEndDate(userId, {
      endDate: new Date(date),
      groupId: join._group._id,
      userId,
    });
    if (res && !res.error) toast.success("Subscription updated successfully");
    setIsEditing(false);
  };

  return (
    <tbody>
      <tr>
        <td
          className="tableLink"
          onClick={() => navigate(`/groups-view/${join._group._id}`)}
        >
          {join._group?.name}
        </td>
        <td>{moment(join?.joinDate).format("DD MMM YYYY")}</td>
        <td>
          {isEditing ? (
            <span>
              <input
                value={date}
                onChange={(e) => setDate(e.target.value)}
                type="date"
              />
            </span>
          ) : (
            moment(join?.subscriptionEndDate).format("DD MMM YYYY")
          )}
          {!isEditing ? (
            <Button color="link">
              <i
                className="fas fa-pencil-alt"
                onClick={() => setIsEditing(!isEditing)}
              ></i>
            </Button>
          ) : (
            <>
              {" "}
              <Button color="link">
                <i className="fas fa-check" onClick={handleChangeDate}></i>
              </Button>
              <Button color="link">
                <i
                  className="fas fa-trash"
                  onClick={() => setIsEditing(false)}
                ></i>
              </Button>
            </>
          )}
        </td>
        <td>
          {join._group?.isPaid ? "$" : null}
          {typeof join?.amount === "number" && !isNaN(join.amount)
            ? `$${join.amount}`
            : "free"}
        </td>
        <td>
          $
          {typeof join?._group?.revenue?.mediaRevenue === "number" &&
          !isNaN(join._group.revenue.mediaRevenue)
            ? join._group.revenue.mediaRevenue.toFixed(2)
            : "0.00"}
        </td>
        <td>{join?.status}</td>
        <td>
          <div className="action">
            <Button color="link" className="delete">
              <i
                className="fas fa-trash-alt"
                onClick={() => _removeMember(join._group._id)}
              ></i>
            </Button>
          </div>
        </td>
      </tr>
    </tbody>
  );
};

export default MembersviewPage;
